import { Component } from '@angular/core';
import { LocalStorageService } from '../../service/local-storage.service';

@Component({
  selector: 'app-committee-members',
  templateUrl: './committee-members.component.html',
  styleUrl: './committee-members.component.scss'
})
export class CommitteeMembersComponent {
  userTypeId:any;
constructor(private localStorageService : LocalStorageService){
  this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
}
}
